/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./assetstokens.vue?vue&type=template&id=28c8b822&scoped=true"
import script from "./assetstokens.vue?vue&type=script&lang=js"
export * from "./assetstokens.vue?vue&type=script&lang=js"
import style0 from "./assetstokens.vue?vue&type=style&index=0&id=28c8b822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c8b822",
  null
  
)

export default component.exports